import { render, staticRenderFns } from "./ChangeLogs.vue?vue&type=template&id=023f82b6&scoped=true&"
import script from "./ChangeLogs.vue?vue&type=script&lang=js&"
export * from "./ChangeLogs.vue?vue&type=script&lang=js&"
import style0 from "./ChangeLogs.vue?vue&type=style&index=0&id=023f82b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023f82b6",
  null
  
)

export default component.exports